import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {Dropdown} from "primereact/dropdown";
import Cookies from "js-cookie";
import {Button} from "primereact/button";

const ThemeselectComponent = (props) => {

  const {t, i18n} = props;

  useEffect(() => {
    if(!Cookies.get('theme')) {
      Cookies.set('theme', 'light', {
        expires: 365,
        secure: JSON.parse(process.env.REACT_APP_APP_COOKIE_SECURE.toLowerCase()),
        sameSite: 'Strict',
        path: '/',
        domain: process.env.REACT_APP_APP_COOKIE_DOMAIN
      });
    }
  }, [])

  return (

    <>
      {Cookies.get('theme') == 'light' &&
        <Button icon="pi pi-moon"
                iconPos="left"
                onClick={() => {
                  Cookies.set('theme', 'dark', {
                    expires: 365,
                    secure: JSON.parse(process.env.REACT_APP_APP_COOKIE_SECURE.toLowerCase()),
                    sameSite: 'Strict',
                    path: '/',
                    domain: process.env.REACT_APP_APP_COOKIE_DOMAIN
                  });
                  document.getElementById('body').classList.add('dark-theme')
                  const themeLink = document.createElement('link');
                  themeLink.rel = 'stylesheet';
                  themeLink.href = '/dark.css';
                  document.head.appendChild(themeLink);
                  window.App.forceUpdate()
                }}
                className={"p-button-link"}
                label={t('dark')}
        />
      }
      {Cookies.get('theme') == 'dark' &&
        <Button icon="pi pi-sun"
                iconPos="left"
                onClick={() => {
                  Cookies.set('theme', 'light', {
                    expires: 365,
                    secure: JSON.parse(process.env.REACT_APP_APP_COOKIE_SECURE.toLowerCase()),
                    sameSite: 'Strict',
                    path: '/',
                    domain: process.env.REACT_APP_APP_COOKIE_DOMAIN
                  });
                  document.getElementById('body').classList.remove('dark-theme')
                  const link = document.querySelector(`link[href="/dark.css"]`);
                  if (link) {
                    link.parentNode.removeChild(link);
                  }
                  window.App.forceUpdate()
                }}
                className={"p-button-link"}
                label={t('light')}
        />
      }
    </>
  )
}
export default withTranslation('common')(ThemeselectComponent);
